import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    labels: [],
    labelsMetadata: {},
    label: {}
  }
})
  .get({
    action: 'getLabels',
    property: 'labels',
    queryParams: true,
    path: '/labels/',
    onSuccess: payloadToState('labels')
  })
  .get({
    action: 'getLabelsFullList',
    queryParams: true,
    path: '/labels/',
    property: 'labels-full-list'
  })
  .post({
    action: 'createLabel',
    property: 'label',
    path: '/labels/',
    onSuccess: payloadToState('label')
  })
  .get({
    action: 'getLabel',
    property: 'label',
    path: ({ id }) => `/labels/${id}`,
    onSuccess: payloadToState('label')
  })
  .put({
    action: 'updateLabel',
    property: 'label',
    path: ({ id }) => `/labels/${id}`,
    onSuccess: payloadToState('label')
  })
  .delete({
    action: 'deleteLabel',
    property: 'label',
    path: ({ id, labelIds }) => `/labels/${id}${labelIds}`,
    beforeRequest: getOptimisticDelete('labels'),
    onSuccess: payloadToState('label')
  })
  .getStore()
